import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legal-cell',
  templateUrl: './legal-cell.component.html',
  styleUrls: ['./legal-cell.component.scss']
})
export class LegalCellComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
